<div>
    <div class="flex" *ngIf="this.data.title">
        <h3> <span *ngIf="this.icon">
                <mat-icon [svgIcon]="this.icon" [color]="this.color" class="pt-1 mr-1"></mat-icon>
            </span>{{this.data.title}}</h3>
    </div>
    <div class="flex flex-row justify-around text-center">
        <span class="flex" *ngIf="!this.data.title">
            <mat-icon [svgIcon]="this.icon" [color]="this.color" class="pr-1"></mat-icon>
        </span>
        <span class="flex">
            {{this.data.msg}}
        </span>
        <span class="flex">
            <mat-icon class="cursor-pointer" svgIcon="close" (click)="this.snackBar.dismiss()"></mat-icon>
        </span>
    </div>
</div>